import { Container } from '@/components/ui/Grid';
import RequestPriceForm from "./RequestPriceForm";
import MotionHeader from "@/components/ui/MotionHeader";

const RequestPrice = ({ data = {} }) => {
    return (
        <Container>
            {data.title && <MotionHeader>{data.title}</MotionHeader>}
            <RequestPriceForm />
        </Container>
    );
};

export default RequestPrice;
